import icon from '../../assets/cashman/rarity-star.png';

export const LocalImage = () => {
    return (
        <div>
            heres your local star
            <img alt="icon" src={icon} />
        </div>
    );
};

export default LocalImage;
